import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@mui/styles';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { CardActionArea } from '@mui/material';
import imageDefault from '../../assets/index.png';

const useStyles = makeStyles(() => ({
  card: {
    margin: '1em 2em',
  },
  description: {
    margin: '2em !important',
  },
  hr: {
    width: '50%',
  },
  media: {
    maxHeight: '300px',
    minHeight: '300px',
  },
}));

const CatCard = ({ cat, maxWidth, maxHeight }) => {
  const classes = useStyles();

  return (
    <Card className={classes.card} sx={{ maxWidth, maxHeight }}>
      <CardActionArea>
        <CardMedia className={classes.media} component="img" image={cat.image} alt={cat.title} />
        <CardContent>
          <Typography gutterBottom variant="h5" component="div">
            {cat.title}
          </Typography>
          <hr className={classes.hr} />
          <Typography className={classes.description} variant="body2" color="text.secondary">
            {cat.description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default CatCard;

CatCard.propTypes = {
  cat: PropTypes.shape({
    image: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
  }),
  maxHeight: PropTypes.number,
  maxWidth: PropTypes.number,
};

CatCard.defaultProps = {
  cat: {
    image: imageDefault,
    title: 'Chat',
    description: 'Tout doux, graou !',
  },
  maxHeight: 470,
  maxWidth: 300,
};
